import { useLocalStorage } from '@vueuse/core';

const LAST_SEEN_KEY = 'system-announcements.last-seen';

export const useSystemAnnouncements = () => {
  const lastSeen = useLocalStorage<string | null>(LAST_SEEN_KEY, null);

  const markSeen = (createdAt: string | null) => {
    if (!createdAt) return;
    if (!lastSeen.value || createdAt > lastSeen.value) {
      lastSeen.value = createdAt;
    }
  };

  const hasUnseen = (latestCreatedAt: string | null | undefined) => {
    if (!latestCreatedAt) return false;
    return !lastSeen.value || latestCreatedAt > lastSeen.value;
  };

  return {
    lastSeen,
    markSeen,
    hasUnseen,
  };
};
